import { useCallback, useMemo, useState } from 'react';
import { EPhoneVerificationStep, PHONE_STEP_TITLE } from '../constants';

export const useVerificationStep = () => {
  const [step, setStep] = useState<EPhoneVerificationStep>(EPhoneVerificationStep.PHONE);
  const gotToPhoneStep = useCallback(() => setStep(EPhoneVerificationStep.PHONE), []);
  const goToVerificationStep = useCallback(() => setStep(EPhoneVerificationStep.VERIFY), []);
  const title = useMemo(() => PHONE_STEP_TITLE[step], [step]);

  return {
    step,
    title,
    gotToPhoneStep,
    goToVerificationStep,
  };
};
